import React from 'react';
import { useSelector } from 'react-redux';
import { CellInfo } from 'react-table';
import AdvancedActionCell from '../../components/action-cell/AdvancedActionCell';
import { ViewFrame, ListTable } from '../../components';
import { selectCustomersList } from '../../store/modules/customers/selectors';
import {
  getCustomerListRequest,
  setCustomerListDirty,
  deleteCustomerRequest,
} from '../../store/modules/customers/actions';
import { useActionDispatcher, useTitle } from '../../hooks';
import DeleteAction from '../../components/action/DeleteAction';

const title = 'Customers';

const CustomersList = () => {
  useTitle(title);

  const { loading, data, dirty } = useSelector(selectCustomersList);
  const getCustomerList = useActionDispatcher(getCustomerListRequest);
  const deleteCustomer = useActionDispatcher(deleteCustomerRequest);
  const setDirty = useActionDispatcher(setCustomerListDirty);

  return (
    <ViewFrame title={title}>
      <ListTable
        columns={[
          {
            id: 'ref.organization.common_name',
            Header: 'Organization',
            width: 130,
          },
          {
            id: 'ref.project.title',
            Header: 'Project',
          },
          {
            id: 'ref.full_name_first_last',
            Header: 'Full Name',
            width: 130,
          },
          {
            id: 'ref.email_protected',
            Header: 'Email',
            width: 90,
          },
          {
            id: 'ref.created_age',
            Header: 'Created',
            width: 100,
          },
          {
            id: 'actions',
            accessor: 'id',
            Cell: (cell: CellInfo) => (
              <AdvancedActionCell>
                {
                  cell.original.permissions.can_delete &&
                  <DeleteAction {...cell} onDelete={deleteCustomer} />
                }
              </AdvancedActionCell>
            ),
            width: 65,
          },
        ]}
        loading={loading}
        data={data}
        fetch={getCustomerList}
        dirty={Boolean(dirty)}
        setDirty={setDirty}
      />
    </ViewFrame>
  );
};

export default CustomersList;
